'use strict'

export default initCopyCodePromoHandler

function initCopyCodePromoHandler() {
    const copyEncart = document.querySelector('.j_bandeau_copy')
    const codePromo = document.querySelector('#promo-code')

    if (!copyEncart || !codePromo) return

    const promoCode = codePromo.textContent.trim()

    if (promoCode) {
        copyEncart.style.cursor = 'pointer'
    }

    copyEncart.addEventListener('click', function () {
        if (!promoCode) return

        navigator.clipboard.writeText(promoCode).then(() => {
            const code = document.getElementById('copy-code')
            code.classList.remove('hidden')
            setTimeout(() => code.classList.add('hidden'), 2000)
        })
    })
}
